import { render } from "./wfm-docpicker.vue?vue&type=template&id=b9328e72&scoped=true"
import script from "./wfm-docpicker.vue?vue&type=script&lang=js"
export * from "./wfm-docpicker.vue?vue&type=script&lang=js"

import "./wfm-docpicker.vue?vue&type=style&index=0&id=b9328e72&lang=css"
import "./wfm-docpicker.vue?vue&type=style&index=1&id=b9328e72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9328e72"]])

export default __exports__